import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import InvoiceFormConfig from "./form";
import styles from "./style.module.scss";
import { InvoiceFormData, InvoiceRelatedAttributes } from "@/formTypes/InvoiceDataType";
import GenericForm, { ConfirmationConfig } from "../GenericForm";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import QuickAddProductForm from "../QuickAddProductForm";
import { Col, Row, Table } from "reactstrap";
import PriceSelector from "@components/dynamic/PriceSelector";
import { PriceApi } from "@/api/PricesApi";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectDocumentSummary, selectEDocumentSummary, selectEDocumentVentaNeta } from "@/store/slices/utils/eDocumentSelectors";
import { ACTIVITY_CODE_LENGTH, FOUR_PRICES_MANAGEMENT_CODE, CREDIT_NOTE_DISCOUNT_TYPE_CODE, INVOICE_CONTADO_TYPE_CODE, INVOICE_HOLDING_TYPE_CODE, ON_INVOICE_DISCOUNT_TYPE_CODE, SITUACION_COMPROBANTE_NORMAL, CASH_PAYMENT_WAY_CODE, DISCOUNT_CODES, TICKET_PRINT_FORMANT_ID, EINVOICE_EXPORT_INVOICE_TYPE_CODE, MERCHANDISE_PRODUCT_TYPE_CODE, TIPO_DE_IDENTIFICACION_EXTRANJERO_NO_DOMICILIADO, RECEPTOR_TAX_REGIME_GENERAL } from "@utils/Constants";
import { addPaymentWay, clearDocument, clearDocumentReferences, setDocumentOtherCharges, setDocumentShippingOptions, clearPaymentWays, loadProducts, setAllProductsExemptionData, setDefaultExemption, setDocumentComments, setDocumentDiscount, setDocumentDiscountCode, setDocumentDiscountType, setDocumentEInvoiceType, setDocumentExempted, setLowStockProducts, setNoPartidaArancelariaProducts, setInvalidCabysProducts, setPrice, setPriceCode, setPriceZeroProducts, setProductExemptionData, setDocumentTaxRegime, restoreDocumentTaxRegime } from "@/store/slices/eDocumentSlides";
import { readClientShippingOptions } from "@utils/ClientShipping";
import { CurrencyApi } from "@/api/CurrencyApi";
import { setCurrency } from "@/store/slices/currencySlides";
import { ActivityCodeApi } from "@/api/ActivityCodeApi";
import LoadingScreen from "@components/content/LoadingScreen";
import EdocumentProductList from "@components/dynamic/EdocumentProductList";
import { ClientApi, ClientDataType } from "@/api/ClientApi";
import { showAlert } from "@utils/Alert";
import {
  QUOTE_APPROVAL_APPROVED,
  QUOTE_APPROVAL_BLOCK_MESSAGE,
  resolveQuoteApprovalStatus,
} from "@utils/quoteApprovalStatus";
import { isNaN } from "mathjs";
import { omitProperties, removeFunctionFromObject, stripHtmlTags, toNumberFormat } from "@utils/Utils";
import { AddClientToDocumentPubSub, AddClientToDocumentPubSubPayload, ConfirmPrintPubSub, CurrencyIdPubSub, LoadInvoiceTemplatePubSub, LoadInvoiceTemplatePubSubPayload, ScrollToDiscountCodeSelectPubSub } from "@utils/pubsubs/PubSub";
import { flushDocumentProductEdits } from "@utils/eDocumentFlush";
import EdocumentComments from "@components/dynamic/EdocumentComments";
import DocumentPaymentWaysForm from "../DocumentPaymentWaysForm";
import { HiddenableContainer } from "@components/layout/HiddenableContainer";
import { EDocumentPaymentWayDataType } from "@/formTypes/EDocumentPaymentWayDataType";
import EdocumentPaymentWayList from "@components/dynamic/EdocumentPaymentWayList";
import DocumentExemptionOffCanvas from "@components/layout/Offcanvas/DocumentExemptionOffCanvas";
import { ProductExemptionDataType } from "@/formTypes/ProductExemptionDataType";
import { buildECreditnoteRequest, generateCustomInformationJson, generatePriceCreditFromInvoice, sendECreditnoteData, sendEInvoiceData } from "@utils/EDocument";
import {
  StoredReference,
  buildAutoReferenceFromInvoice,
  mergeReferences,
  serializeStoredReferences,
  toInfoRefElements,
} from "@utils/DocumentReferences";
import {
  parseStoredOtherCharges,
  resolveOtherCharges,
  serializeStoredOtherCharges,
  serviceTaxCharge,
} from "@utils/DocumentOtherCharges";
import CustomDocumentFields from "@components/dynamic/CustomDocumentFields";
import { getCurrentDateTime } from "@utils/Api";
import { InvoiceProductDataType } from "@/api/InvoiceProductApi";
import { InvoicePaymentDataType } from "@/api/InvoicePaymentApi";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { distinctCabysCodes, resolveCabysCodes } from "@utils/cabysCatalog";
import { describePreflightIssues, findPreflightLineIssues, findPreflightLineWarnings, LineDiagnosticRow } from "@utils/edocumentDiagnostic";
import ConfirmModal from "@components/content/ConfirmModal";
import { calculateTotalIVADevuelto, toEdocumentPaymentWays } from "@utils/IvaDevuelto";
import { resolveSaleConditionCode, shouldCapturePaymentWays } from "@utils/SaleCondition";
import { InvoiceFormDataKeys } from "@/generated/InvoiceFormDataKeys";
import { QuoteApi } from "@/api/QuoteApi";
import { QuoteFormDataKeys } from "@/generated/QuoteFormDataKeys";
import { QuoteRelatedAttributes } from "@/formTypes/QuoteDataType";
import { EasyposEInvoice } from "@/atv/submitInvoice";
import { generateAndUploadPdf } from "@utils/htmlExport";
import { documentPdfS3Key, documentPrintPath } from "@utils/documentPdf";
import { exceedsPendingSubmissionLimit, fetchInvoiceWithProducts } from "@utils/pendingENoteSubmission";
import { checkCreditnoteTicketPrint, checkInvoiceTicketPrint } from "@utils/ticketPrintUtils";
import { SHIPPING_GUIDE_QUERY_PARAM, shippingGuideUrl } from "@utils/ShippingGuide";
import DocumentPrintConfirmation from "@components/content/DocumentPrintConfirmation";
import { ProductApi } from "@/api/ProductsApi";
import { CreditnoteApi, CreditnoteDataType } from "@/api/CreditnoteApi";
import { CreditnoteProductDataType } from "@/api/CreditnoteProductApi";
import { WithHolding } from "@/formTypes/DocumentClientType";
import SearchClientByIdentificationOffCanvas from "@components/layout/Offcanvas/SearchClientByIdentificationOffCanvas";
import { loadReferenceFormLabel } from "@utils/Forms";
import { buildDocumentCopyFormValues, endDocumentPreload, resolveDocumentClientNames, resolveStoredDocumentDiscount } from "@utils/documentClientSnapshot";

/** Atributos de la factura origen que no se copian al crear una nueva desde duplicado. */
const INVOICE_COPY_STRIP_FIELDS = [
  "id",
  "numero",
  "sequence",
  "invoice_key",
  "fecha",
  "cerrada",
  "anulada",
  "pagada",
  "status",
  "edocument_status_payload",
  "recibeId",
  "salemanId",
  "createdAt",
  "updatedAt",
  "einvoice_status",
] as const;

/**
 * Campos que la factura necesita y el modelo Quote no persiste: al facturar desde una
 * cotizacion se rellenan con la ficha del cliente. Solo aplica a esa rama; al duplicar
 * una factura manda el snapshot del documento origen.
 */
const QUOTE_CLIENT_FALLBACK_FIELDS = ["tipo", "einvoice_kind", "with_user_info", "plazo", "salemanId", "razon_social", "tax_regime"] as const;

/**
 * Tope de espera del catalogo de CAByS de Hacienda al validar antes de emitir. Facturar es el
 * camino mas sensible a la latencia del sistema: si Hacienda tarda se sigue sin verificar las
 * tarifas, en vez de dejar al cajero esperando.
 */
const CABYS_PREFLIGHT_TIMEOUT_MS = 4000;

/** Aviso de tarifas distintas al CAByS que espera la decision del usuario para emitir. */
type TaxRateWarning = {
  rows: LineDiagnosticRow[];
  resolve: (confirmed: boolean) => void;
}

type InvoiceFormProps = {
  id?: string;
  copyData?: boolean
  formId: string,
  quoteId?: string,
  saveRedirectUrl: string
}


const InvoiceForm = (props: InvoiceFormProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const { copyData = false, id: preLoadedInvoiceId, quoteId } = props
  const formRef = useRef<DynamicFormRef>(null);
  const customFieldForm = useRef<DynamicFormRef>(null);
  const isPreloadingDocumentRef = useRef(false);

  const [defaultData, setDefaultData] = useState<InvoiceDataType>({});
  const [clients, setClients] = useState<ClientDataType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences);
  const documentCurrency = useAppSelector((state) => state.currency);
  const documentSummary = useAppSelector(selectDocumentSummary);
  const [easyposEInvoice, setEasyposEInvoice] = useState<EasyposEInvoice>()
  const [documentType, setDocumentType] = useState<string>("0");
  const [montoInicial, setMontoInicial] = useState<number>(0);
  const [formConfig, setFormConfig] = useState<any>();
  const [taxRateWarning, setTaxRateWarning] = useState<TaxRateWarning>();
  const noAutoCancelContado = suscriptionData?.no_auto_cancel_contado || false;
  const capturePaymentWays = shouldCapturePaymentWays(documentType, noAutoCancelContado);

  useEffect(() => {
    setIsLoading(true)
    loadFormConfig()
    loadDefaultData()
    if (suscriptionData) {
      setEasyposEInvoice(new EasyposEInvoice(suscriptionData))
    }
  }, [suscriptionData])

  useEffect(() => {
    const unsubscribe = AddClientToDocumentPubSub.subscribe(addClientToDocument);
    const unsubscribeInvoiceTemplate = LoadInvoiceTemplatePubSub.subscribe(loadInvoiceTemplate);
    dispatch(clearDocument())
    return () => {
      unsubscribe();
      unsubscribeInvoiceTemplate();
    };
  }, []);

  const loadFormConfig = () => {
    const formConfig = loadReferenceFormLabel(InvoiceFormConfig, suscriptionData);
    if (suscriptionData?.id) {
      setFormConfig(formConfig)
    }
  }

  const loadInvoiceTemplate = (payload: LoadInvoiceTemplatePubSubPayload) => {
    const { invoiceTemplate } = payload;

    if (invoiceTemplate?.id) {
      const defaultFormData: InvoiceDataType = {
        currencyId: invoiceTemplate.currencyId,
        exenta: invoiceTemplate.exenta
      }
      formRef.current?.setFormValue("multiple", defaultFormData, "multipleData")
    }

    dispatch(setDocumentDiscount(Number(invoiceTemplate?.porcenta_descuento || 0)))
    dispatch(setDocumentExempted(invoiceTemplate?.exenta || false))
    dispatch(setDocumentOtherCharges(parseStoredOtherCharges(invoiceTemplate?.otros_cargos)))
    dispatch(loadProducts(invoiceTemplate?.invoiceTemplateProducts as EDocumentProductDataType[]))
  }

  const addClientToDocument = (payload: AddClientToDocumentPubSubPayload) => {
    const { client } = payload;
    setClients([
      ...clients,
      client
    ])
    populateClientData(client)
    formRef.current?.reFetchSelectInput("clientId")
  }

  const onInputUpdate = (name: keyof InvoiceFormData | "monto_inicial", value: any, event?: React.ChangeEvent<any>) => {
    if (name === "clientId") {
      if (isPreloadingDocumentRef.current) {
        return;
      }
      const client = clients.find(c => c.id === value);
      if (client?.id) {
        populateClientData(client);
      }
    }
    if (name === "tipo") {
      setDocumentType(value)
      // El tipo de documento decide si se cobran formas de pago: al pasar a uno que no
      // las captura hay que soltar las que quedaron en el estado del documento.
      if (!shouldCapturePaymentWays(value, noAutoCancelContado)) {
        dispatch(clearPaymentWays())
      }
    }

    if (name === "monto_inicial") {
      setMontoInicial(value)
    }
    if (name === "einvoice_kind") {
      dispatch(setDocumentEInvoiceType(value))
    }
    // Al precargar un documento su tarifa especial se restaura sin tocar las lineas guardadas.
    if (name === "tax_regime" && !isPreloadingDocumentRef.current) {
      dispatch(setDocumentTaxRegime(value))
    }
  }

  const setClientPrice = async (client: ClientDataType) => {
    if (suscriptionData?.pricemanaged === FOUR_PRICES_MANAGEMENT_CODE) {
      let priceCode = Number(client.priceId || 1);
      if (isNaN(priceCode)) {
        priceCode = 1
      }
      dispatch(setPriceCode(priceCode))
    } else {
      if (typeof client.price == "function") {
        const { data } = await client.price()
        let priceData = removeFunctionFromObject(data)
        dispatch(setPrice(priceData))
      }
    }
  }

  const createClientDataObject = (client: ClientDataType): InvoiceDataType => {
    const clientDefaultDocumentType = `${(client.tipo || 0)}`; ``
    const clientData: InvoiceDataType = {
      clientId: client.id,
      ...resolveDocumentClientNames(client),
      plazo: client.plazo || 0,
      tel1: client.telefono1,
      tel1_cd: client.telefono1_cd,
      tel2: client.telefono2,
      tel2_cd: client.telefono2_cd,
      email: client.email,
      tipo_identificacion: client.tipo_identificacion,
      identificacion: client.identificacion,
      direccion: stripHtmlTags(client.direccion || ""),
      tipo: clientDefaultDocumentType,
      einvoice_kind: client.einvoice_kind || "0",
      with_user_info: client.with_user_info,
      clientActivitycode: client.activitycode,
      tax_regime: client.tax_regime || RECEPTOR_TAX_REGIME_GENERAL,
      // El vendedor asignado al cliente solo se propaga si existe: cuando el cliente no
      // tiene uno, se respeta el que el usuario haya seleccionado a mano en el documento.
      ...(client.salemanId ? { salemanId: client.salemanId } : {}),
    }

    return clientData
  }

  /**
   * Subconjunto de la ficha del cliente con los campos que el modelo Quote no persiste.
   * Solo se usa al facturar desde una cotizacion.
   */
  const buildQuoteClientFallback = (client?: ClientDataType): InvoiceDataType => {
    if (!client?.id) {
      return {}
    }
    const clientData = createClientDataObject(client)
    return QUOTE_CLIENT_FALLBACK_FIELDS.reduce((fallback: InvoiceDataType, key) => {
      const value = clientData[key];
      return value == null ? fallback : { ...fallback, [key]: value }
    }, {})
  }

  const populateClientData = async (client: ClientDataType) => {
    if (client?.id) {

      const clientDefaultDocumentType = `${(client.tipo || 0)}`;
      const clientData = createClientDataObject(client)
      if (client.discountCode) {
        dispatch(setDocumentDiscountCode(`${client.discountCode}` as keyof typeof DISCOUNT_CODES))
      }

      setDocumentType(clientDefaultDocumentType)
      formRef.current?.setFormValue("multiple",
        {
          ...clientData,
          client_code: client.codigo
        }
        , "multipleData");
      let descuento = Number(client.descuento || 0);
      if (isNaN(descuento)) {
        descuento = 0;
      }

      dispatch(setDocumentDiscount(descuento))
      dispatch(setDocumentDiscountType(client.tipo_descuento || ON_INVOICE_DISCOUNT_TYPE_CODE))
      dispatch(setDocumentTaxRegime(client.tax_regime))
      dispatch(setDocumentShippingOptions(readClientShippingOptions(client)))
      await setClientPrice(client as ClientDataType)
    }
  }

  const onInputKeyDown = (name: keyof InvoiceFormData | "client_code", event?: React.KeyboardEvent<any>) => {
    if (name === "client_code") {
      if (event?.key == "Enter") {
        event?.preventDefault();
        event?.stopPropagation();
        const input = event.target as HTMLInputElement
        selectClientByCode(input.value)
      }
    }
  }

  const selectClientByCode = async (code: string) => {
    const client = clients.find(c => c.codigo === code);
    if (client?.id) {
      formRef.current?.setFormValue("clientId", client.id, "String");
    } else {
      showAlert("danger", "No existe ningun cliente con ese codigo");
    }
  }

  const addPaymentWayToDocument = (data: EDocumentPaymentWayDataType) => {
    dispatch(addPaymentWay(data))
  }

  const onAddExemption = (exemptionChange?: ProductExemptionDataType) => {
    if (exemptionChange?.productId) {
      dispatch(setProductExemptionData({
        productId: `${exemptionChange?.productId}`,
        exemption: exemptionChange
      }))
    } else if (exemptionChange) {
      dispatch(setAllProductsExemptionData({
        exemption: exemptionChange
      }))
      dispatch(setDefaultExemption(exemptionChange))
    }
  }

  /**
   * En cotización y duplicado manda el documento origen; solo si no trae código de
   * actividad se cae al de la suscripción, porque el bloque de valores por defecto de
   * loadDefaultData no corre en esas ramas.
   */
  const withDefaultActivityCode = async <T extends { activitycode?: string | null }>(formData: T): Promise<T> => {
    if (formData.activitycode) {
      return formData
    }
    const defaultActivityCode = await ActivityCodeApi.getDefaultActivityCode()
    if (!defaultActivityCode?.code) {
      return formData
    }
    return { ...formData, activitycode: `${defaultActivityCode.code}` }
  }

  const preLoadQuoteData = async (clients: ClientDataType[]) => {
    if (quoteId) {
      let quote = await QuoteApi.get(quoteId, {
        selectionSet: [
          ...QuoteFormDataKeys.filter(k => !QuoteRelatedAttributes.includes(k)),
          "currency.*",
          "client.*",
          "quoteProducts.*",
          "quoteProducts.product.*"
        ]
      })

      // Cubre el acceso directo por URL: el boton del listado ya filtra, pero la ruta
      // /user/invoices/fromQuote/:quoteId es alcanzable a mano.
      if (suscriptionData?.quote_approval_flow) {
        const approvalStatus = resolveQuoteApprovalStatus(quote.approval_status);
        if (approvalStatus !== QUOTE_APPROVAL_APPROVED) {
          showAlert("danger", QUOTE_APPROVAL_BLOCK_MESSAGE[approvalStatus]);
          navigate("/user/quotes");
          return;
        }
      }

      const client = clients.find(c => c.id == quote.clientId);

      // Todo lo que recalcula lineas va antes de `loadProducts`, para que la cotizacion
      // conserve lo que guardo: `setDocumentDiscount` sobrescribe el
      // `porcentaje_descuento` de cada linea, `setDocumentDiscountType` decide si el
      // impuesto se calcula con el descuento restado, y `setPrice` reevalua el precio de
      // cada linea contra la lista del cliente. Corriendo con el documento vacio, el
      // precio del cliente solo aplica a los productos que se agreguen despues.
      if (client?.id) {
        await setClientPrice(client)
        dispatch(setDocumentShippingOptions(readClientShippingOptions(client)))
      }

      const storedDiscount = resolveStoredDocumentDiscount(quote);
      dispatch(setDocumentDiscountType(storedDiscount.documentDiscountType))
      dispatch(setDocumentDiscount(storedDiscount.documentDiscount))
      if (storedDiscount.documentDiscountCode) {
        dispatch(setDocumentDiscountCode(storedDiscount.documentDiscountCode))
      }
      dispatch(setDocumentExempted(storedDiscount.isDocumentExempted))

      if (quote.quoteProducts) {
        const invoiceProducts = quote.quoteProducts.map(ip => {
          return omitProperties(ip, ["id", "quoteId", "createdAt", "updatedAt"], true);
        })
        dispatch(loadProducts(invoiceProducts as EDocumentProductDataType[]))
      }
      // La cotizacion no guarda la tarifa especial: se toma del cliente y se aplica a sus lineas.
      dispatch(setDocumentTaxRegime(client?.tax_regime))

      const formData = omitProperties(quote, ["comments", "numero", "id", "createdAt", "updatedAt", "quoteProducts", "reserved_until"], true);
      dispatch(setDocumentComments(`${quote.comments || ""}`))
      dispatch(setDocumentOtherCharges(parseStoredOtherCharges(quote.otros_cargos)))

      const clientFallback = buildQuoteClientFallback(client);
      // `formData` gana: `omitProperties(..., true)` ya quito los nulos de la cotizacion,
      // asi que el fallback solo rellena lo que la cotizacion no puede guardar.
      const formValues = await withDefaultActivityCode({ ...clientFallback, ...formData });

      setDocumentType(`${formValues.tipo ?? 0}`);
      dispatch(setDocumentEInvoiceType(`${formValues.einvoice_kind ?? "0"}`))

      isPreloadingDocumentRef.current = true;
      formRef.current?.resetFormValue(
        buildDocumentCopyFormValues(formValues, client)
      );
      endDocumentPreload(isPreloadingDocumentRef);

      if (formData.customfields) {
        try {
          const customFields = JSON.parse(formData.customfields);
          const fieldData = customFields.reduce((a: Record<string, string>, v: { title: string, value: string, }) => {
            return {
              ...a,
              [v.title]: v.value
            }
          }, {})
          customFieldForm.current?.resetFormValue(fieldData)
        } catch (err) {
          console.log("error parsing json")
        }
      }


      if (quote.currency && quote.currencyId) {
        CurrencyIdPubSub.publish({ currencyId: quote.currencyId })
      }
    }
  }

  const preLoadInvoiceData = async (clients: ClientDataType[]) => {
    if (preLoadedInvoiceId) {
      let invoice = await InvoiceApi.get(preLoadedInvoiceId, {
        selectionSet: [
          ...InvoiceFormDataKeys.filter(k => !InvoiceRelatedAttributes.includes(k)),
          "currency.*",
          "client.*",
          "invoiceProducts.*",
          "invoiceProducts.product.*"
        ]
      })
      // Igual que al facturar desde una cotizacion: el descuento se restaura antes de
      // cargar las lineas, porque `setDocumentDiscount` pisa el descuento de cada una.
      const storedDiscount = resolveStoredDocumentDiscount(invoice);
      dispatch(setDocumentDiscountType(storedDiscount.documentDiscountType))
      dispatch(setDocumentDiscount(storedDiscount.documentDiscount))
      if (storedDiscount.documentDiscountCode) {
        dispatch(setDocumentDiscountCode(storedDiscount.documentDiscountCode))
      }
      dispatch(setDocumentExempted(storedDiscount.isDocumentExempted))

      const formData = omitProperties(invoice, [...INVOICE_COPY_STRIP_FIELDS], true);
      const client = clients.find(c => c.id == formData.clientId);
      setDocumentType(`${invoice.tipo ?? formData.tipo ?? 0}`);
      dispatch(setDocumentEInvoiceType(`${invoice.einvoice_kind ?? "0"}`))

      const formValues = await withDefaultActivityCode(formData);
      isPreloadingDocumentRef.current = true;
      formRef.current?.resetFormValue(
        buildDocumentCopyFormValues(formValues, client)
      );
      endDocumentPreload(isPreloadingDocumentRef);
      dispatch(setDocumentComments(`${formData.document_comments || ""}`))
      dispatch(setDocumentOtherCharges(parseStoredOtherCharges(invoice.otros_cargos)))
      dispatch(setDocumentShippingOptions(client ? readClientShippingOptions(client) : []))

      if (formData.customfields) {
        try {
          const customFields = JSON.parse(formData.customfields);
          const fieldData = customFields.reduce((a: Record<string, string>, v: { title: string, value: string, }) => {
            return {
              ...a,
              [v.title]: v.value
            }
          }, {})
          customFieldForm.current?.resetFormValue(fieldData)
        } catch (err) {
          console.log("error parsing json")
        }
      }

      // Antes de `loadProducts`: las lineas conservan la tarifa con que se facturaron.
      dispatch(restoreDocumentTaxRegime(invoice.tax_regime))
      if (invoice.invoiceProducts) {
        const invoiceProducts = invoice.invoiceProducts.map(ip => {
          return omitProperties(ip, ["id", "invoiceId", "createdAt", "updatedAt"], true);
        })
        dispatch(loadProducts(invoiceProducts as EDocumentProductDataType[]))
      }
      if (invoice.currency && invoice.currencyId) {
        CurrencyIdPubSub.publish({ currencyId: invoice.currencyId })
      }
    }
  }

  /**
   * Precarga el impuesto de servicio como cargo tipo 06 cuando la suscripcion lo tiene
   * activo (`aplicar_imp_servicio` / `imp_servicio` del perfil). Es lo que reemplaza a
   * la vieja linea "propina": el usuario ve el cargo en el panel de totales y puede
   * quitarlo desde "Otros Cargos" antes de guardar.
   */
  const applyDefaultServiceCharge = () => {
    if (!suscriptionData?.aplicar_imp_servicio) {
      return
    }
    dispatch(setDocumentOtherCharges([serviceTaxCharge(Number(suscriptionData.imp_servicio || 10))]))
  }

  const loadDefaultData = async (resetLoad = false) => {
    try {
      const { items: allClients } = await ClientApi.fetchAll();
      setClients(allClients);
      if (quoteId && !resetLoad) {
        await preLoadQuoteData(allClients)
      } else if (copyData && !resetLoad) {
        await preLoadInvoiceData(allClients)
      } else {
        dispatch(clearDocument())
        applyDefaultServiceCharge()
        let defaultData: InvoiceDataType = {}
        const defaultPrice = await PriceApi.getDefaultPrice()

        if (typeof defaultPrice === 'number') {
          dispatch(setPriceCode(defaultPrice))
        } else {
          let priceData = removeFunctionFromObject(defaultPrice)
          dispatch(setPrice(priceData))
        }
        const defaultCurrency = await CurrencyApi.getDefaultCurrency()
        if (defaultCurrency.id) {
          dispatch(setCurrency(removeFunctionFromObject(defaultCurrency)))
          defaultData["currencyId"] = defaultCurrency.id
          if (defaultCurrency.exchange_rate) {
            defaultData["exchange_rate"] = defaultCurrency.exchange_rate
          }
          CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id })
        }
        const defaultActivityCodeCurrency = await ActivityCodeApi.getDefaultActivityCode()
        if (defaultActivityCodeCurrency.code) {
          defaultData["activitycode"] = `${defaultActivityCodeCurrency.code}`
        }

        formRef.current?.setFormValue("multiple", defaultData, "multipleData")
        setDefaultData(defaultData)
        if (resetLoad) {
          formRef.current?.resetFormValue(defaultData)
          customFieldForm.current?.resetFormValue()
        }
        const defaultClient = (allClients as ClientDataType[]).find(c => c.is_default);
        if (defaultClient && defaultClient.id) {
          setTimeout(() => {
            formRef.current?.setFormValue("clientId", defaultClient.id, "select");
          });
        }
      }
    } finally {
      setIsLoading(false)
    }
  }

  const createInvoice = async (formData: InvoiceDataType): Promise<InvoiceDataType> => {
    const eDocumentState = flushDocumentProductEdits();
    const documentSummaryState = selectEDocumentSummary(eDocumentState);
    let invoiceData: InvoiceDataType = {}
    let creditnoteDiscountAmount = 0
    const { documentProducts = [], documentDiscountType, documentPaymentWays, isDocumentExempted, documentDiscountCode } = eDocumentState
    if (formData.tipo == INVOICE_HOLDING_TYPE_CODE) {
      if (documentSummaryState.total <= Number((formData as WithHolding<InvoiceDataType>).monto_inicial || 0)) {
        throw Error("El abono inicial no puede ser mayor que el valor de la facturar")
      }
    }

    let products = [...documentProducts];
    if (products?.length == 0) {
      throw Error("Por favor agregue algun producto a la factura")
    }

    if (documentDiscountType == ON_INVOICE_DISCOUNT_TYPE_CODE) {
      if (documentSummaryState.descuento > 0 && !documentDiscountCode) {
        ScrollToDiscountCodeSelectPubSub.publish({})
        throw Error("Por favor seleccione un codigo de descuento antes de continuar")
      } else {
        invoiceData["discountCode"] = documentDiscountCode
      }
    } else if (documentDiscountType == CREDIT_NOTE_DISCOUNT_TYPE_CODE) {
      if (documentSummaryState.descuento > 0) {
        creditnoteDiscountAmount = documentSummaryState.descuento
        products = products.map(p => {
          return {
            ...p,
            descuento: 0
          }
        })
      }
    }

    if (!suscriptionData) {
      throw Error("No fue posible obtener la informacion de su suscripcion")
    }

    const lowStockProducts = await ProductApi.checkStock(products as EDocumentProductDataType[], suscriptionData)
    if (lowStockProducts.length > 0) {
      dispatch(setLowStockProducts(lowStockProducts))
      throw Error("No hay existencias suficientes de algunos productos por favor corrigalas existencias de los productos no validos")
    }

    const priceZeroProducts = products.filter(p => p.subtotal == 0);
    if (priceZeroProducts.length > 0) {
      dispatch(setPriceZeroProducts(priceZeroProducts))
      throw Error("Algunas lineas tiene monto igual a 0 por favor ajuste el precio de la linea o eliminela de la factura")
    }

    // Solo con facturacion electronica activa: sin ella el documento no viaja a Hacienda y
    // un CAByS incoherente no tiene consecuencias.
    if (suscriptionData.einvoice_status) {
      const cabysInfo = await resolveCabysCodes(
        distinctCabysCodes(products.map(p => p.product?.codigo_cabys || p.codigo_cabys)),
        { timeoutMs: CABYS_PREFLIGHT_TIMEOUT_MS }
      )
      // Si Hacienda no respondio, `cabysInfo` viene incompleto y esas lineas no se evaluan:
      // un catalogo caido no puede impedir facturar (ver los 307 de api.hacienda.go.cr).
      const lineOptions = {
        receptorTaxRegime: eDocumentState.documentTaxRegime,
        documentType: `${formData.einvoice_kind ?? eDocumentState.documentEInvoiceType ?? ""}`,
      }
      const documentLines = products as EDocumentProductDataType[]
      // `lineNumber` es 1-based sobre este mismo arreglo, asi se recuperan las lineas a marcar.
      const linesOf = (rows: LineDiagnosticRow[]) =>
        rows.map(row => products[row.lineNumber - 1]) as EDocumentProductDataType[]

      const cabysIssues = findPreflightLineIssues(documentLines, cabysInfo, lineOptions)
      if (cabysIssues.length > 0) {
        dispatch(setInvalidCabysProducts(linesOf(cabysIssues)))
        throw Error(describePreflightIssues(cabysIssues))
      }

      // La tarifa del CAByS es solo referencia de Hacienda: la diferencia se confirma, no se bloquea.
      const taxRateWarnings = findPreflightLineWarnings(documentLines, cabysInfo, lineOptions)
      if (taxRateWarnings.length > 0) {
        dispatch(setInvalidCabysProducts(linesOf(taxRateWarnings)))
        const confirmed = await confirmTaxRateWarnings(taxRateWarnings)
        if (!confirmed) {
          throw Error("Emision cancelada. Revise la tarifa de IVA de las lineas marcadas")
        }
      }
      dispatch(setInvalidCabysProducts([]))
    }

    if (eDocumentState.documentEInvoiceType == EINVOICE_EXPORT_INVOICE_TYPE_CODE) {
      const noPartidaProducts = products.filter(p => p.tipo_producto == MERCHANDISE_PRODUCT_TYPE_CODE && !p.partidaArancelaria)
      if (noPartidaProducts.length > 0) {
        dispatch(setNoPartidaArancelariaProducts(noPartidaProducts))
        throw Error("Al ser una factura de exportacion es necesario asignar las partidas arancelarias a las mercancias de esta factura. Realize la asignacion pendiente con el menu de cada linea")
      } else {
        dispatch(setNoPartidaArancelariaProducts([]))
      }
    }

    // Con no_auto_cancel_contado el contado no se cobra al facturar: no se piden ni se
    // guardan formas de pago, el documento nace pendiente y se cancela con un Recibo.
    const capturePayments = shouldCapturePaymentWays(formData.tipo, noAutoCancelContado)

    const totalPaymentWays = documentPaymentWays?.reduce((a, p) => a + Number(p.monto || 0), Number(0)) || 0;
    if (capturePayments) {
      // El total del comprobante se reduce por el IVA Devuelto (servicios de salud
      // pagados con tarjeta), asi que los medios de pago pueden cubrir ese monto neto.
      const amountToPay = formData.tipo == INVOICE_HOLDING_TYPE_CODE
        ? montoInicial
        : documentSummaryState.total - getDocumentIVADevuelto(products, documentPaymentWays)
      if (totalPaymentWays < amountToPay) {
        throw Error("Las formas de pago no cubren el monto del documento")
      }
    }

    const customField = await customFieldForm.current?.getFormData()

    if (eDocumentState.hasAdditionalData) {
      if (!customField) {
        throw Error("Por favor ingrese la informacion addicional que es obligatoria")
      } else {
        invoiceData["customfields"] = generateCustomInformationJson(customField)
      }
    }

    let pagada = false;
    let status = "pendiente";
    if (formData.tipo == INVOICE_CONTADO_TYPE_CODE) {
      if (!noAutoCancelContado) {
        pagada = true;
        status = "pagada";
      }
    }

    const esApartado = formData.tipo == INVOICE_HOLDING_TYPE_CODE

    invoiceData = {
      ...(omitProperties(formData, ["monto_inicial"])),
      ...invoiceData,
      subtotal: documentSummaryState.subtotal,
      descuento: documentDiscountType == ON_INVOICE_DISCOUNT_TYPE_CODE ? documentSummaryState.descuento : 0,
      impuestos: documentSummaryState.impuestos,
      total: documentSummaryState.total,
      currencyId: documentCurrency.currencyApiId,
      descuento_con_nota: documentDiscountType == CREDIT_NOTE_DISCOUNT_TYPE_CODE,
      es_apartado: esApartado,
      fecha: getCurrentDateTime(),
      exenta: isDocumentExempted,
      pagada,
      status,
      saleCondition: Number(resolveSaleConditionCode(formData.tipo, esApartado, noAutoCancelContado)),
      porcenta_descuento: eDocumentState.documentDiscount,
      document_comments: eDocumentState.documentComments,
      // El slice es el que aplico la tarifa a las lineas: es la fuente de verdad del regimen.
      tax_regime: eDocumentState.documentTaxRegime || RECEPTOR_TAX_REGIME_GENERAL
    }

    if (invoiceData.tipo_identificacion == TIPO_DE_IDENTIFICACION_EXTRANJERO_NO_DOMICILIADO
      && invoiceData.einvoice_kind != EINVOICE_EXPORT_INVOICE_TYPE_CODE) {
      throw Error(`Al seleccionar El tipo de identificacion como Extranjero no domiciliado es
         necesario selection el tipo de facturacion electronica como Factura electronica de exportacion`)
    }

    // Red final: la actividad economica va como CodigoActividadEmisor en el XML de Hacienda,
    // asi que no puede salir vacia ni con un codigo que no exista (el "0" del form viejo).
    if (`${invoiceData.activitycode || ""}`.length != ACTIVITY_CODE_LENGTH) {
      throw Error("Por favor seleccione una actividad economica valida para la factura")
    }

    if (products) {
      const invoicePayments = capturePayments ? generateInvoicePayments(documentPaymentWays, invoiceData) : [];
      if (documentReferences && documentReferences.length > 0) {
        invoiceData.info_references = serializeStoredReferences(documentReferences as StoredReference[])
      }
      // Se resuelven contra la venta neta final: un cargo porcentual definido antes
      // de agregar lineas guarda un `montoCargo` viejo, y el total del documento sale
      // del selector (ya recalculado). Incondicional porque al duplicar `formData`
      // arrastra el `otros_cargos` del origen y quitarlos tiene que poder vaciarlo.
      invoiceData.otros_cargos = serializeStoredOtherCharges(
        resolveOtherCharges(eDocumentState.documentOtherCharges, selectEDocumentVentaNeta(eDocumentState)),
      )
      // Los bultos y el transporte quedan en la factura para poder reimprimir la guia despues.
      // Incondicional por lo mismo que `otros_cargos`: al duplicar una factura hay que poder
      // dejarla sin guia.
      const shippingGuide = eDocumentState.documentShippingGuide
      invoiceData.bultos = Number(shippingGuide?.bultos || 0)
      invoiceData.shipping_carrier = `${shippingGuide?.carrier || ""}`
      const createdInvoice = await InvoiceApi.createInvoiceAndProducts(invoiceData, products as InvoiceProductDataType[], invoicePayments)
      // Sin `?guide=1`: la guia no debe salir en el PDF que se adjunta al correo de
      // facturacion electronica.
      await generateAndUploadPdf(`/user/invoices/print/${createdInvoice.id}/0/1`, `${suscriptionData?.numero}/pdfs/Invoice/${createdInvoice.invoice_key}.pdf`)

      if (easyposEInvoice && suscriptionData?.einvoice_status) {
        const refsForLambda = documentReferences && documentReferences.length > 0
          ? toInfoRefElements(documentReferences as StoredReference[])
          : undefined
        await sendEInvoiceData(easyposEInvoice, `${createdInvoice.id}`, refsForLambda)
      }

      // Se espera a proposito: la nota tiene que existir antes de publicar la impresion,
      // para poder imprimirla junto con la factura.
      const discountCreditnote = documentDiscountType == CREDIT_NOTE_DISCOUNT_TYPE_CODE
        ? await createDiscountCreditNote(`${createdInvoice.id}`, products.length, creditnoteDiscountAmount)
        : undefined

      clearForm()
      showAlert("success", "La Factura ha sido creada existosamente")

      const printGuide = Number(shippingGuide?.bultos || 0) > 0
      ConfirmPrintPubSub.publish({
        openOffCanvas: true,
        printVersionUrl: `/user/invoices/print/${createdInvoice.id}/0/1${printGuide ? `?${SHIPPING_GUIDE_QUERY_PARAM}=1` : ""}`,
        // La nota de credito de descuento se imprime junto con la factura: es parte del
        // mismo cobro y el cliente se lleva las dos.
        extraPrintUrls: discountCreditnote?.id
          ? [documentPrintPath("Creditnote", `${discountCreditnote.id}`)]
          : undefined,
        // En formato tiquete la factura no pasa por la ruta de impresion, asi que la guia
        // (que siempre es carta) hay que abrirla aparte.
        ticketPrintCallBack: () => {
          checkInvoiceTicketPrint(suscriptionData, createdInvoice)
          // desactivado tempora de la impresion de ntoas de credito de descuento
          // if (discountCreditnote) {
          //   checkCreditnoteTicketPrint(suscriptionData, discountCreditnote)
          // }
          if (printGuide) {
            window.open(shippingGuideUrl(`${createdInvoice.id}`))
          }
        },
      })
      
      return createdInvoice;
    }

    return {} as InvoiceDataType;
  }

  /**
   * Nota de credito por el descuento de la factura.
   *
   * No se envia al ATV aqui: la nota referencia a la factura en <InformacionReferencia> y
   * si ambas salen a la vez Hacienda puede validar la nota antes de tener registrada la
   * factura y la rechaza. Se guarda el payload ya armado en `pending_submission` y la
   * lambda submit-pending-enote lo envia en cuanto la factura tiene respuesta del ATV.
   */
  const createDiscountCreditNote = async (
    invoiceId: string,
    invoiceLineCount: number,
    creditnoteDiscountAmount: number,
  ): Promise<CreditnoteDataType | undefined> => {
    try {
      const invoice = await fetchInvoiceWithProducts(invoiceId, invoiceLineCount)
      const { creditnote,
        products } = generatePriceCreditFromInvoice(invoice, "Descuento generado por factura ", creditnoteDiscountAmount)
      const createdCreditnote = await CreditnoteApi.createCreditnoteAndProducts(creditnote, products as CreditnoteProductDataType[], false)

      if (easyposEInvoice && suscriptionData?.einvoice_status && createdCreditnote.id) {
        const autoRef = buildAutoReferenceFromInvoice(
          invoice,
          "notaDeCredito",
          `${createdCreditnote.description}`,
        )
        const mergedRefs = mergeReferences([autoRef], [])
        await CreditnoteApi.update(createdCreditnote.id, {
          info_references: serializeStoredReferences(mergedRefs),
        })
        const pendingSubmission = JSON.stringify(
          await buildECreditnoteRequest(easyposEInvoice, createdCreditnote.id, toInfoRefElements(mergedRefs), products.length),
        )
        if (exceedsPendingSubmissionLimit(pendingSubmission)) {
          // No cabe en el item de DynamoDB: se envia en el acto antes que dejar la nota
          // guardada sin nadie que la envie.
          console.warn("[descuento con nota] payload demasiado grande para diferir, se envia de una")
          await sendECreditnoteData(easyposEInvoice, createdCreditnote.id, toInfoRefElements(mergedRefs))
        } else {
          await CreditnoteApi.update(createdCreditnote.id, {
            pending_submission: pendingSubmission,
          })
        }
      }

      // Despues del payload a proposito: para entonces ya se confirmo que las lineas de la
      // nota son legibles, asi que la vista de impresion no sale a medias. El PDF tiene que
      // quedar en S3 antes de que Hacienda acepte la nota, porque es el que EdocumentSender
      // adjunta al correo del comprobante.
      await generateAndUploadPdf(
        documentPrintPath("Creditnote", `${createdCreditnote.id}`),
        documentPdfS3Key("Creditnote", suscriptionData?.numero, `${createdCreditnote.document_key}`),
      )

      showAlert("success", `Se genero la nota de credito #${createdCreditnote.numero} por descuento de ${toNumberFormat(creditnoteDiscountAmount)}. Se enviara a Hacienda en cuanto la factura quede registrada`)
      return createdCreditnote;
    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
      return undefined;
    }

  }

  /**
   * IVA Devuelto del documento en edicion (anexo v4.4). Solo es distinto de cero
   * cuando hay lineas de servicios de salud al 4% cubiertas con tarjeta.
   */
  const getDocumentIVADevuelto = (products: EDocumentProductDataType[], payment: EDocumentPaymentWayDataType[] = []): number => {
    const ventaNeta = products.reduce((a, p) => a + Number(p.subtotal || 0) - Number(p.descuento || 0), Number(0))
    const paymentWays = toEdocumentPaymentWays(
      payment.map(p => ({ formaPago: p.forma_pago, monto: p.monto, vuelto: 0 }))
    )
    return calculateTotalIVADevuelto(products, paymentWays, ventaNeta)
  }

  const generateInvoicePayments = (payment: EDocumentPaymentWayDataType[] = [], invoiceData: InvoiceDataType): InvoicePaymentDataType[] => {
    const paymentTotal = payment.reduce((a, v) => a + Number(v.monto || 0), Number(0))
    let moneyBack = paymentTotal - Number(documentSummary?.total || 0)

    return payment.map(p => {
      let vuelto = Number(0)
      if (p.forma_pago == `${CASH_PAYMENT_WAY_CODE}`) {
        vuelto = moneyBack
        moneyBack = 0
      }
      const invoicePayment: InvoicePaymentDataType = {
        descripcion: invoiceData.tipo == INVOICE_HOLDING_TYPE_CODE ? `Abono inicial apartado` : `Pago Factura`,
        monto: Number(p.monto),
        vuelto: vuelto,
        formaPago: Number(p.forma_pago),
        digitosTarjeta: p.digitosTarjeta,
        numAprobacion: p.numAprobacion,
        exchangeRate: invoiceData.exchange_rate,
        created: invoiceData.fecha,
        currencyId: invoiceData.currencyId,
        bankAccountId: p.bankAccountId,
        creditOperatorId: p.creditOperatorId
      }
      return invoicePayment
    })

  }

  const confirmTaxRateWarnings = (rows: LineDiagnosticRow[]): Promise<boolean> =>
    new Promise(resolve => setTaxRateWarning({ rows, resolve }))

  const resolveTaxRateWarning = (confirmed: boolean) => {
    taxRateWarning?.resolve(confirmed)
    setTaxRateWarning(undefined)
  }

  const clearForm = async () => {
    dispatch(clearDocument())
    setMontoInicial(0);
    loadDefaultData(true)
  }

  const getCreateConfirmation = (): ConfirmationConfig | undefined => {
    const { ask_confirm = false } = suscriptionData || {}
    if (ask_confirm) {
      return {
        message: "Esta seguro que desea crear la Factura"
      }
    }
  }

  const onClientSelected = (clientData?: ClientDataType) => {
    const clientInvoiceData: InvoiceDataType = {
      clientActivitycode: clientData?.activitycode,
      ...resolveDocumentClientNames(clientData || {}),
      identificacion: clientData?.identificacion,
      tipo_identificacion: clientData?.tipo_identificacion
    }
    formRef.current?.setFormValue("multiple", clientInvoiceData, "multipleData")
  }

  return (
    <>
      {formConfig?.sections && (<GenericForm<InvoiceFormData, InvoiceDataType>
        ref={formRef}
        formId={props.formId}
        defaultData={defaultData}
        modelRelativeObjects={InvoiceRelatedAttributes}
        onInputChange={onInputUpdate}
        onInputKeyDown={onInputKeyDown}
        formConfig={formConfig}
        confirmationConfig={getCreateConfirmation()}
        getById={(...arg) => InvoiceApi.get(...arg)}
        createFn={(...arg) => createInvoice(...arg)}
      >
        <CustomDocumentFields ref={customFieldForm} documentType="invoice" />
        <Row>
          <Col>
            <h3>
              Productos
            </h3>
          </Col>
          <Col xs="1">
            <PriceSelector />
          </Col>
        </Row>
        <QuickAddProductForm />
        <EdocumentProductList showOtherCharges={true} />
        <EdocumentComments />
      </GenericForm >
      )}

      <HiddenableContainer show={capturePaymentWays}>
        <Row>
          <Col md={{
            size: 10,
            offset: 1
          }}>
            <hr />
            <h3 className="mb-4">
              Agregar Forma de Pago
            </h3>
            <DocumentPaymentWaysForm innerForm={true} onPaymentWayAdded={addPaymentWayToDocument} />
            <hr className="mt-4 mb-4" />
            <EdocumentPaymentWayList montoInicial={INVOICE_HOLDING_TYPE_CODE == documentType ? montoInicial : 0} documentSummary={documentSummary} />
          </Col>
        </Row>
      </HiddenableContainer>
      <DocumentExemptionOffCanvas onAddExemption={onAddExemption} />
      <LoadingScreen isLoading={isLoading} />
      <DocumentPrintConfirmation
        title="Imprimir Factura"
      />
      <SearchClientByIdentificationOffCanvas
        onClientSelected={onClientSelected}
      />
      <ConfirmModal
        isOpen={!!taxRateWarning}
        toggle={() => resolveTaxRateWarning(false)}
        title="Tarifa de IVA distinta al CAByS"
        primaryBtn="Emitir de todas formas"
        primaryBtnColor="warning"
        secondaryBtn="Revisar tarifas"
        secondaryBtnColor="secondary"
        testId="tax-rate-warning"
        onConfirm={() => resolveTaxRateWarning(true)}
        onCancel={() => resolveTaxRateWarning(false)}
      >
        <p>
          Estas lineas llevan una tarifa de IVA distinta a la que el catalogo de Hacienda le asigna a su CAByS.
          Hacienda publica esa tarifa solo como referencia: emita solo si la ley fija otra tarifa para esta venta
          (por ejemplo, servicios de salud privados o insumos agropecuarios a un comprador no inscrito en el MAG).
        </p>
        <Table size="sm" responsive>
          <thead>
            <tr>
              <th>Codigo</th>
              <th>Descripcion</th>
              <th>Tarifa CAByS</th>
              <th>Tarifa facturada</th>
            </tr>
          </thead>
          <tbody>
            {taxRateWarning?.rows.map(row => (
              <tr key={row.lineNumber} data-testid={`tax-rate-warning-row-${row.lineNumber}`}>
                <td>{row.codigo}</td>
                <td>{row.description}</td>
                <td>{row.catalogTaxRate}%</td>
                <td>{row.sentTaxRate}%</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ConfirmModal>
    </>

  )
}

export default InvoiceForm;